import { put, takeEvery, call } from "redux-saga/effects";
import { guestConstants } from "../constants";
import { callAPI } from "./commonApiCall";
import apiURLs from "../config/url-config";
import { setUserDetails } from "../utils/user";
import { guestActions, alertActions } from "../actions";
import { Encryption } from "../utils/Encryption";

//#region User Login/register/logout/user profile
function* userLogin(action) {
  try {
    const data = yield call(callAPI, apiURLs.loginCheckUrl, action.payload);

    if (data.status === true) {
      data.data = JSON.parse((new Encryption()).decrypt(data.data));
      yield call(setUserDetails, data.data);
      yield put(guestActions.loginSuccess(data.data));
    } else {
      yield put(alertActions.error(data.message));
    }
  } catch (error) {
    yield put(guestActions.loginFailure);
  }
}

function* checkEmailExist(action) {
  try {
    const data = yield call(
      callAPI,
      apiURLs.checkEmailExistUrl,
      action.payload
    );

    if (data) {
      yield put(guestActions.checkEmailExistSuccess(data));
    }
  } catch (error) {
    yield put(guestActions.checkEmailExistFailure(error));
  }
}

function* userSignup(action) {
  try {
    const data = yield call(callAPI, apiURLs.signupUrl, action.payload);

    if (data.status === true) {
      yield call(setUserDetails, data.data);
      yield put(guestActions.signupSuccess(data.data));
    } else {
      yield put(alertActions.error(data.message));
    }
  } catch (error) {
    yield put(guestActions.signupFailure(error));
  }
}

//#region Forget Password functions
function* forgetPassword(action) {
  try {
    const data = yield call(callAPI, apiURLs.forgetPasswordUrl, action.payload);
    if (data.status === true) {
      yield put(alertActions.success(data.message));
      yield put(guestActions.forgotPasswordSuccess());
    } else {
      yield put(alertActions.error(data.message));
    }
  } catch (error) {
    yield put(guestActions.forgotPasswordFailure(error));
  }
}

function* validateSetPassword(action) {
  try {
    const data = yield call(callAPI, apiURLs.validateTokenUrl, action.payload);
    yield put(guestActions.validateSetPasswordTokenSuccess(data));

    if (!data || !data.status) {
      yield put(alertActions.error(data.message));
    }
  } catch (error) {}
}

function* setPassword(action) {
  try {
    const data = yield call(
      callAPI,
      apiURLs.setTokenPasswordUrl,
      action.payload
    );
    yield put(guestActions.setPasswordSuccess(data));

    if (data.status === true) {
      yield put(alertActions.success(data.message));
    } else {
      yield put(alertActions.error(data.message));
    }
  } catch (error) {}
}
//#endregion



export function* guestSaga() {
  yield takeEvery(guestConstants.LOGIN_REQUEST, userLogin);
  yield takeEvery(guestConstants.FORGOTPWD_REQUEST, forgetPassword);
  yield takeEvery(guestConstants.EMAIL_EXIST_REQUEST, checkEmailExist);
  yield takeEvery(guestConstants.REGISTER_REQUEST, userSignup);
  yield takeEvery(
    guestConstants.VALIDATE_PASSWORD_TOKEN_REQUEST,
    validateSetPassword
  );
  yield takeEvery(guestConstants.SET_PASSWORD_REQUEST, setPassword); 
}
